module.exports = __webpack_public_path__ + "static/media/018-Verlassen_ID_1.5d9fa282.mp3";